<div class="mb-4 mt-4" *ngIf="decisionInput$ | async as decisionInput">
  <div class="data-table">
    <div class="loading-shade" *ngIf="isLoadingResults">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>

    <div class="d-flex justify-content-between align-items-baseline">
      <mat-label class="font-weight-bold field-required">{{ 'forms.common.Criteria.ErrorsData' | translate }}
      </mat-label>
      <div *ngIf="!decisionInput.viewOnly && !disabled && decisionInput.executeVisitType == institutionEntries">
        <button mat-icon-button matTooltip="{{ 'forms.common.Add' | translate }}" (click)="showMistake(decisionInput)">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="mistakeLevel">
        <th mat-header-cell *matHeaderCellDef>
          <strong> {{ "forms.common.Criteria.mistakeLevel" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="content" *ngIf="row?.mistakeLevel">{{ ('forms.common.Criteria.' + row?.mistakeLevel) | translate
            }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="criterionKey">
        <th mat-header-cell *matHeaderCellDef>
          <strong> {{ "forms.common.Criteria.MasarCriteria" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="content">
            <span *ngIf="row?.criterionKey" class="d-inline-block font-weight-bold mx-1 px-2 py-1 chip">
              {{ row?.criterionKey }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="mistake">
        <th mat-header-cell *matHeaderCellDef>
          <strong> {{ "forms.common.Criteria.mistake" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="content">{{ row?.mistake }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="suggestedSolution">
        <th mat-header-cell *matHeaderCellDef>
          <strong> {{ "forms.common.Criteria.suggestedSolution" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="content">{{ row?.suggestedSolution }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row;let i = index" style="width: 50px">
          <div class="d-flex justify-content-end" *ngIf="!decisionInput.viewOnly && !disabled">
            <button mat-icon-button (click)="showMistake(decisionInput,row,false,i)">
              <mat-icon>edit_note</mat-icon>
            </button>
            <button mat-icon-button (click)="deleteMistake(row.id)">
              <mat-icon color="warn">delete_forever</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="noRecord">
        <td colspan="6" class="text-center" mat-footer-cell *matFooterCellDef>
          {{ "forms.common.No items added yet" | translate }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'deleted': row?.deleted}"></tr>

      <tr [hidden]="!!dataSource?.length" mat-footer-row *matFooterRowDef="
          dataSource?.length === 0 ? ['noRecord'] : []
          "></tr>
    </table>
  </div>
</div>